import { ApiState, PaginationType } from "../../redux.type";
import { BusAdmin } from "../BusAdmin/BusAdmin.util";

export enum LogType {
  REGISTER = "REGISTER",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
}

export type Log = {
  id: number;

  activity: string;
  extra: string;
  type: LogType;
  device: string;
  logTable: string;
  createdAt: string;
  updatedAt: string;

  busAdmin: BusAdmin;
};

export type LogStateTypes = {
  logs: ApiState<Log[]>;
  pagedLogs: ApiState<PaginationType<Log[]>>;
  logCount: ApiState<number | null>;
  updateLogSeen: ApiState<any>;

  resetStates: ApiState<null>;
};
